import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import type { Notice as Interface } from '../../design/components';
import { randomMessageForTone, ShimmerText, StaticText } from '../shared/notice';

export const Notice: React.FC<Interface> = ({ state, tone = 'loading', animated, detail }) => {
  // useMemo([tone]), not useState — App.tsx gate swaps reconcile the
  // same Notice instance across tone changes; a useState initializer
  // would freeze on the original pool. See native/Notice.tsx for full
  // reasoning.
  const fallback = useMemo(() => randomMessageForTone(tone), [tone]);
  const [text, Icon] = state?.[0] ? [state[0], null] : fallback;
  const shouldAnimate = animated ?? tone === 'loading';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1.5, p: 4 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
        {shouldAnimate
          ? <ShimmerText text={text} Icon={Icon} colors={['#757575', '#d6d6d6']} iconColor="#9e9e9e" />
          : <StaticText text={text} Icon={Icon!} color="#757575" iconColor="#9e9e9e" />
        }
      </Box>
      {detail && <Box sx={{ color: '#9e9e9e', fontSize: '0.875rem' }}>{detail}</Box>}
    </Box>
  );
};
